<template>
  <div class="luxury-phone-frame mx-auto my-3">
        <universal-qr-modal 
          v-model="showQrDialog"
          :title="value?.label?.labelName?.text || 'کیوآر لیبل قیمت'"
          :subtitle="'برای دریافت اطلاعات کیوار زیر را اسکن کنید'"
          :identifier="value?.identifier|| ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
    
    <!-- ۱. هدر اختصاصی تصویر محصول -->
    <div class="header-outer-container position-relative flex-shrink-0" >
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن QR کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18" color="green">mdi-qrcode-scan</v-icon>
        </v-btn>

      <!-- نشان تخفیف -->
      <!-- <div class="badge-wrapper" v-if="hasDiscount">
        <div class="badge d-flex flex-col">
          <v-icon class="flame-anim fire fire2">mdi-fire</v-icon>
          <span class="fire2">{{ toPersian(value.label.discount.text) }}٪</span>
          <span class="fire2">تخفیف</span>
        </div>
      </div> -->

      <!-- کارت هدر داینامیک -->
      <v-card 
        v-if="value?.photo?.profile"
        elevation="3"
        class="header-card position-relative d-flex align-center justify-center overflow-hidden"
        :style="headerDynamicStyle"
      >
        <!-- پس‌زمینه هدر -->
        <div
          v-if="!!value?.photo?.headBackground"
          class="header-bg-img"
          :style="{ backgroundImage: `url(${value.photo.headBackground})` }"
        ></div>

        <!-- افکت‌های نوری پس‌زمینه -->
        <div class="bokeh-orb orb-1"></div>
        <div class="bokeh-orb orb-2"></div>

        <!-- فریم عکس محصول -->
        <div 
          class="profile-hero-frame"
          :style="profileHeroStyle"
        >
          <v-img
            :src="value.photo.profile"
            class="profile-hero-img"
            :aspect-ratio="profileRatioValue"
            contain
            @load="onImageLoad"
          >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular indeterminate color="primary" size="28" />
              </div>
            </template>
          </v-img>
        </div>
      </v-card>

    </div>

    <!-- ۲. بدنه اصلی شامل نام محصول و سایر اطلاعات -->
    <div class="body-scroll-container position-relative">
      <div
        class="body-showcase pa-3 pa-sm-4 position-relative"
        :style="{
          background: !!value?.photo?.background ? 'transparent' : (value?.pallete?.bodyColor || '#6BA4B8'),
          backgroundColor: value?.pallete?.bodyColor || '#6BA4B8'
        }"
      >
        <!-- پس‌زمینه محو بدنه -->
        <div
          v-if="!!value?.photo?.background"
          class="body-bg-layer"
          :style="{
            backgroundImage: `url(${value.photo.background})`,
          }"
        ></div>

        <!-- کارت عنوان و مشخصات اصلی محصول -->
        <div 
          v-if="hasHeaderTexts" 
          class="lux-card product-title-card mb-3 pa-3 position-relative" 
          style="z-index: 2;"
        >
          <h1
            class="product-main-name font-weight-black mb-1"
            :style="textColorStyle"
          >
            {{ value?.label?.labelName?.text || "نام محصول" }}
          </h1>

          <div class="d-flex flex-wrap align-center justify-space-between mt-2 pt-2 border-top-light">
            <span
              v-if="isValidValue(value?.label?.name?.text)"
              class="store-subname font-weight-bold"
              :style="textColorStyle"
            >
              <v-icon small class="ml-1" :style="textColorStyle">mdi-store-outline</v-icon>
              {{ value.label.name.text }}
            </span>
          </div>
        </div>

        <!-- سرتیتر مشخصات و قیمت -->
        <div class="d-flex align-center justify-space-between mb-3 px-2 top-meta-bar position-relative" style="z-index: 2;">
          <div class="d-flex align-center">
            <span class="section-bullet ml-2" :style="bulletDynamicStyle"></span>
            <span class="meta-title font-weight-black" :style="textColorStyle">مشخصات و قیمت نهایی</span>
          </div>
        </div>

        <!-- حالت Drag & Drop پنل مدیریت -->
        <drag-list v-if="isPreview" v-model="label" style="width: 100%; position: relative; z-index: 2;">
          <template v-slot:default="{ item }">
            <div class="w-100">
                            <!-- برند محصول -->
              <template
                v-if="
                  item === 'brand' &&
                  isValidValue(value?.label?.brand?.text)
                "
              >
                <div class="lux-card mb-3 pa-3 d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <div class="lux-icon-box ml-3">
                      <v-icon size="24" class="anim-tilt dynamic-icon" :style="iconDynamicStyle">mdi-tag-outline</v-icon>
                    </div>
                    <div class="card-item-title font-weight-black" :style="textColorStyle">برند</div>
                  </div>

                  <div class="d-flex align-center">
                    <div class="brand-badge-pill" :style="textColorStyle">
                      {{ value.label.brand.text }}
                    </div>
                    <v-icon class="lux-drag-handle mr-2">mdi-drag-vertical</v-icon>
                  </div>
                </div>
              </template>

              <!-- تخفیف ویژه -->
              <template v-if="item === 'discount' && hasDiscount">
                <div class="lux-card mb-3 pa-3 d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <div class="lux-icon-box ml-3 anim-pulse-box">
                      <v-icon size="24" class="anim-jiggle dynamic-icon" :style="iconDynamicStyle">mdi-percent</v-icon>
                    </div>
                    <div>
                      <div class="card-item-title font-weight-black" :style="textColorStyle">تخفیف ویژه</div>
                      <div v-if="savedAmount > 0" class="profit-highlight">
                        سود شما: {{ formatPrice(savedAmount) }} ریال
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-center">
                    <div class="discount-pill-tag">
                      {{ toPersian(value.label.discount.text) }}٪
                    </div>
                    <v-icon class="lux-drag-handle mr-2">mdi-drag-vertical</v-icon>
                  </div>
                </div>
              </template>

              <!-- قیمت فروشگاه -->
              <template
                v-if="
                  item === 'cPrice' &&
                  isValidValue(value?.label?.cPrice?.text) &&
                  Number(value.label.cPrice.text) > 0
                "
              >
                <div class="lux-card mb-3 pa-3 d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <div class="lux-icon-box ml-3">
                      <v-icon size="24" class="anim-bounce dynamic-icon" :style="iconDynamicStyle">mdi-account-cash</v-icon>
                    </div>
                    <div class="card-item-title font-weight-black" :style="textColorStyle">قیمت فروشگاه</div>
                  </div>

                  <div class="d-flex align-center">
                    <div class="price-wrapper">
                      <span class="price-number" :style="textColorStyle">{{ formatPrice(value.label.cPrice.text) }}</span>
                      <span class="price-curr">ریال</span>
                    </div>
                    <v-icon class="lux-drag-handle mr-2">mdi-drag-vertical</v-icon>
                  </div>
                </div>
              </template>

              <!-- قیمت مصرف‌کننده -->
              <template
                v-if="
                  item === 'bPrice' &&
                  isValidValue(value?.label?.bPrice?.text) &&
                  Number(value.label.bPrice.text) > 0
                "
              >
                <div class="lux-card mb-3 pa-3 d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <div class="lux-icon-box ml-3">
                      <v-icon size="24" class="anim-heartbeat dynamic-icon" :style="iconDynamicStyle">mdi-tag-heart</v-icon>
                    </div>
                    <div>
                      <div class="card-item-title font-weight-black" :style="textColorStyle">قیمت مصرف‌کننده</div>
                      <div v-if="hasDiscount" class="discount-sub-info">
                        شامل {{ toPersian(value.label.discount.text) }}٪ تخفیف
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-center">
                    <div class="text-left mr-2">
                      <div v-if="hasDiscount" class="strikethrough-price">
                        <span class="price-number">{{ formatPrice(value.label.bPrice.text) }}</span>
                        <span class="price-curr">ریال</span>
                      </div>
                      <div>
                        <span class="price-number active-price" :style="textColorStyle">{{ formatPrice(finalConsumerPrice) }}</span>
                        <span class="price-curr">ریال</span>
                      </div>
                    </div>
                    <v-icon class="lux-drag-handle mr-2">mdi-drag-vertical</v-icon>
                  </div>
                </div>
              </template>

              <!-- قیمت تولید -->
              <template
                v-if="
                  item === 'price' &&
                  isValidValue(value?.label?.price?.text) &&
                  Number(value.label.price.text) > 0
                "
              >
                <div class="lux-card mb-3 pa-3 d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <div class="lux-icon-box ml-3">
                      <v-icon size="24" class="anim-wiggle dynamic-icon" :style="iconDynamicStyle">mdi-factory</v-icon>
                    </div>
                    <div class="card-item-title font-weight-black" :style="textColorStyle">قیمت تولید</div>
                  </div>

                  <div class="d-flex align-center">
                    <div class="price-wrapper">
                      <span class="price-number" :style="textColorStyle">{{ formatPrice(value.label.price.text) }}</span>
                      <span class="price-curr">ریال</span>
                    </div>
                    <v-icon class="lux-drag-handle mr-2">mdi-drag-vertical</v-icon>
                  </div>
                </div>
              </template>

              <!-- درباره محصول -->
              <template
                v-if="
                  item === 'about' &&
                  isValidValue(value?.label?.about?.text)
                "
              >
                <div class="lux-card mb-3 pa-3">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div class="d-flex align-center">
                      <div class="lux-icon-box ml-3">
                        <v-icon size="22" class="anim-glow-float dynamic-icon" :style="iconDynamicStyle">mdi-information-outline</v-icon>
                      </div>
                      <div class="card-item-title font-weight-black" :style="textColorStyle">درباره محصول</div>
                    </div>
                    <v-icon class="lux-drag-handle">mdi-drag-vertical</v-icon>
                  </div>

                  <div
                    class="desc-content"
                    :class="{ 'desc-collapsed': isAboutCollapsed }"
                    :style="textColorStyle"
                  >
                    {{ value.label.about.text }}
                  </div>

                  <div
                    v-if="value?.label?.about?.collapse !== false && shouldShowReadMore(value.label.about.text)"
                    class="read-more-btn mt-2"
                    @click="isAboutExpanded = !isAboutExpanded"
                  >
                    <span>{{ isAboutExpanded ? 'بستن توضیحات' : 'مشاهده بیشتر...' }}</span>
                    <v-icon small class="mr-1">{{ isAboutExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </div>
                </div>
              </template>

              <!-- توضیحات تکمیلی محصول -->
              <template
                v-if="
                  item === 'discriptions' &&
                  isValidValue(value?.label?.discriptions?.text)
                "
              >
                <div class="lux-card mb-3 pa-3">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div class="d-flex align-center">
                      <div class="lux-icon-box ml-3">
                        <v-icon size="22" class="anim-tilt dynamic-icon" :style="iconDynamicStyle">mdi-text-box-outline</v-icon>
                      </div>
                      <div class="card-item-title font-weight-black" :style="textColorStyle">توضیحات تکمیلی</div>
                    </div>
                    <v-icon class="lux-drag-handle">mdi-drag-vertical</v-icon>
                  </div>

                  <div
                    class="desc-content"
                    :class="{ 'desc-collapsed': isDescCollapsed }"
                    :style="textColorStyle"
                  >
                    {{ value.label.discriptions.text }}
                  </div>

                  <div
                    v-if="value?.label?.discriptions?.collapse !== false && shouldShowReadMore(value.label.discriptions.text)"
                    class="read-more-btn mt-2"
                    @click="isDescExpanded = !isDescExpanded"
                  >
                    <span>{{ isDescExpanded ? 'بستن توضیحات' : 'مشاهده بیشتر...' }}</span>
                    <v-icon small class="mr-1">{{ isDescExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </drag-list>

        <!-- پیش‌نمایش نهایی استاتیک -->
        <div v-else class="w-100 position-relative" style="z-index: 2;">
          <template v-for="(orderedItem, idx) in resolvedOrder">
            <div
              v-if="orderedItem === 'discount' && hasDiscount"
              :key="'st-dc-' + idx"
              class="lux-card mb-3 pa-3 d-flex align-center justify-space-between"
            >
              <div class="d-flex align-center">
                <div class="lux-icon-box ml-3 anim-pulse-box">
                  <v-icon size="24" class="anim-jiggle dynamic-icon" :style="iconDynamicStyle">mdi-percent</v-icon>
                </div>
                <div>
                  <div class="card-item-title font-weight-black" :style="textColorStyle">تخفیف ویژه</div>
                  <div v-if="savedAmount > 0" class="profit-highlight">
                    سود شما: {{ formatPrice(savedAmount) }} ریال
                  </div>
                </div>
              </div>
              <div class="discount-pill-tag">
                {{ toPersian(value.label.discount.text) }}٪
              </div>
            </div>

            <div
              v-else-if="
                orderedItem === 'cPrice' &&
                isValidValue(value?.label?.cPrice?.text) &&
                Number(value.label.cPrice.text) > 0
              "
              :key="'st-cp-' + idx"
              class="lux-card mb-3 pa-3 d-flex align-center justify-space-between"
            >
              <div class="d-flex align-center">
                <div class="lux-icon-box ml-3">
                  <v-icon size="24" class="anim-bounce dynamic-icon" :style="iconDynamicStyle">mdi-account-cash</v-icon>
                </div>
                <div class="card-item-title font-weight-black" :style="textColorStyle">قیمت فروشگاه</div>
              </div>
              <div class="price-wrapper">
                <span class="price-number" :style="textColorStyle">{{ formatPrice(value.label.cPrice.text) }}</span>
                <span class="price-curr">ریال</span>
              </div>
            </div>

            <div
              v-else-if="
                orderedItem === 'bPrice' &&
                isValidValue(value?.label?.bPrice?.text) &&
                Number(value.label.bPrice.text) > 0
              "
              :key="'st-bp-' + idx"
              class="lux-card mb-3 pa-3 d-flex align-center justify-space-between"
            >
              <div class="d-flex align-center">
                <div class="lux-icon-box ml-3">
                  <v-icon size="24" class="anim-heartbeat dynamic-icon" :style="iconDynamicStyle">mdi-tag-heart</v-icon>
                </div>
                <div>
                  <div class="card-item-title font-weight-black" :style="textColorStyle">قیمت مصرف‌کننده</div>
                  <div v-if="hasDiscount" class="discount-sub-info">
                    شامل {{ toPersian(value.label.discount.text) }}٪ تخفیف
                  </div>
                </div>
              </div>
              <div class="price-wrapper text-left">
                <div v-if="hasDiscount" class="strikethrough-price">
                  {{ formatPrice(value.label.bPrice.text) }}
                </div>
                <div>
                  <span class="price-number active-price" :style="textColorStyle">{{ formatPrice(finalConsumerPrice) }}</span>
                  <span class="price-curr">ریال</span>
                </div>
              </div>
            </div>

            <div
              v-else-if="
                orderedItem === 'price' &&
                isValidValue(value?.label?.price?.text) &&
                Number(value.label.price.text) > 0
              "
              :key="'st-pr-' + idx"
              class="lux-card mb-3 pa-3 d-flex align-center justify-space-between"
            >
              <div class="d-flex align-center">
                <div class="lux-icon-box ml-3">
                  <v-icon size="24" class="anim-wiggle dynamic-icon" :style="iconDynamicStyle">mdi-factory</v-icon>
                </div>
                <div class="card-item-title font-weight-black" :style="textColorStyle">قیمت تولید</div>
              </div>
              <div class="price-wrapper">
                <span class="price-number" :style="textColorStyle">{{ formatPrice(value.label.price.text) }}</span>
                <span class="price-curr">ریال</span>
              </div>
            </div>
                        <div
              v-else-if="
                orderedItem === 'brand' &&
                isValidValue(value?.label?.brand?.text)
              "
              :key="'st-br-' + idx"
              class="lux-card mb-3 pa-3 d-flex align-center justify-space-between"
            >
              <div class="d-flex align-center">
                <div class="lux-icon-box ml-3">
                  <v-icon size="24" class="anim-tilt dynamic-icon" :style="iconDynamicStyle">mdi-tag-outline</v-icon>
                </div>
                <div class="card-item-title font-weight-black" :style="textColorStyle">برند</div>
              </div>
              <div class="brand-badge-pill" :style="textColorStyle">
                {{ value.label.brand.text }}
              </div>
            </div>

            <div
              v-else-if="
                orderedItem === 'about' &&
                isValidValue(value?.label?.about?.text)
              "
              :key="'st-ab-' + idx"
              class="lux-card mb-3 pa-3"
            >
              <div class="d-flex align-center mb-2">
                <div class="lux-icon-box ml-3">
                  <v-icon size="22" class="anim-glow-float dynamic-icon" :style="iconDynamicStyle">mdi-information-outline</v-icon>
                </div>
                <div class="card-item-title font-weight-black" :style="textColorStyle">درباره محصول</div>
              </div>
              <div
                class="desc-content"
                :class="{ 'desc-collapsed': isAboutCollapsed }"
                :style="textColorStyle"
              >
                {{ value.label.about.text }}
              </div>
              <div
                v-if="value?.label?.about?.collapse !== false && shouldShowReadMore(value.label.about.text)"
                class="read-more-btn mt-2"
                @click="isAboutExpanded = !isAboutExpanded"
              >
                <span>{{ isAboutExpanded ? 'بستن توضیحات' : 'مشاهده بیشتر...' }}</span>
                <v-icon small class="mr-1">{{ isAboutExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </div>
            </div>

            <div
              v-else-if="
                orderedItem === 'discriptions' &&
                isValidValue(value?.label?.discriptions?.text)
              "
              :key="'st-ds-' + idx"
              class="lux-card mb-3 pa-3"
            >
              <div class="d-flex align-center mb-2">
                <div class="lux-icon-box ml-3">
                  <v-icon size="22" class="anim-tilt dynamic-icon" :style="iconDynamicStyle">mdi-text-box-outline</v-icon>
                </div>
                <div class="card-item-title font-weight-black" :style="textColorStyle">توضیحات تکمیلی</div>
              </div>
              <div
                class="desc-content"
                :class="{ 'desc-collapsed': isDescCollapsed }"
                :style="textColorStyle"
              >
                {{ value.label.discriptions.text }}
              </div>
              <div
                v-if="value?.label?.discriptions?.collapse !== false && shouldShowReadMore(value.label.discriptions.text)"
                class="read-more-btn mt-2"
                @click="isDescExpanded = !isDescExpanded"
              >
                <span>{{ isDescExpanded ? 'بستن توضیحات' : 'مشاهده بیشتر...' }}</span>
                <v-icon small class="mr-1">{{ isDescExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- فوتر ثابت پایین -->
    <div 
      class="fixed-footer w-100 position-absolute d-flex flex-column align-center pb-2 pt-3 px-4 elevation-10" 
      style="bottom: 0; z-index: 10; background: rgba(255,255,255,0.85); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(10px); border-top-left-radius: 20px; border-top-right-radius: 20px;"
    >     
      <div class="d-flex align-center justify-center opacity-70" @click="openLink">
                <img src="/media/cr_logo.webp" alt="Terminal Ads Logo" height="18" style="filter: grayscale(30%);" />
        <span class="text-caption font-weight-medium mr-2" style="color: #666;">قدرت گرفته از کیوآر لند</span>
      </div>
    </div>
   
  </div>
</template>

<script>
import UniversalQrModal from "../../../components/UniversalQrModal.vue";
import dragList from "../../qrland/dragList.vue";


export default {
  name: "priceLabelTheme",
  components: {
    dragList,
    UniversalQrModal
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    order: {
      type: Array,
      default: () => [],
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },
  data() {
    return {
      showQrDialog:false,
      isAboutExpanded: false,
      isDescExpanded: false,
      naturalRatio: null,
    };
  },
  computed: {
    profileRatioValue() {
      if (this.naturalRatio) return this.naturalRatio;
      const r = Number(this.value?.photo?.profileRatio);
      return (!isNaN(r) && r > 0) ? r : 1;
    },

    headerDynamicStyle() {
      const ratio = this.profileRatioValue;
      return {
        background: !!this.value?.photo?.headBackground ? 'transparent' : (this.value?.pallete?.headColor || '#1e293b'),
        backgroundColor: this.value?.pallete?.headColor || '#1e293b',
        padding: '12px',
        height: 'auto',        // ارتفاع خودکار متناسب با عکس
        minHeight: 'unset',    // حذف هرگونه ارتفاع حداقلی
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    },

    profileHeroStyle() {
      const ratio = this.profileRatioValue;

      if (ratio > 1.05) {
        return {
          width: '100%',
          height: 'auto',
          aspectRatio: `${ratio}`,
        };
      }

      if (ratio < 0.95) {
        return {
          width: 'auto',
          height: '345px',
          maxHeight: '100%',
          aspectRatio: `${ratio}`,
        };
      }

      return {
        width: '100%',
        maxWidth: '345px',
        aspectRatio: '1 / 1',
        height: 'auto',
      };
    },

    hasHeaderTexts() {
      return (
        this.isValidValue(this.value?.label?.labelName?.text) ||
        this.isValidValue(this.value?.label?.name?.text) ||
        this.isValidValue(this.value?.label?.brand?.text)
      );
    },
    headColor() {
      const raw = this.value?.pallete?.headColor;
      if (!raw) return "#00838F";
      const match = raw.match(/#[a-fA-F0-9]{3,8}/);
      return match ? match[0] : (raw.startsWith("#") ? raw : "#00838F");
    },
    textColor() {
      return this.value?.pallete?.textColor || "#0f172a";
    },
    iconDynamicStyle() {
      return {
        color: `${this.headColor} !important`,
        caretColor: `${this.headColor} !important`,
      };
    },
    textColorStyle() {
      return {
        color: `${this.textColor} !important`,
      };
    },
    bulletDynamicStyle() {
      return {
        backgroundColor: `${this.textColor} !important`,
      };
    },
    isAboutCollapsed() {
      const shouldCollapse = this.value?.label?.about?.collapse !== false;
      return shouldCollapse && !this.isAboutExpanded;
    },
    isDescCollapsed() {
      const shouldCollapse = this.value?.label?.discriptions?.collapse !== false;
      return shouldCollapse && !this.isDescExpanded;
    },
    label: {
      get() {
        return this.order;
      },
      set(val) {
        this.$emit("update:order", val);
      },
    },
    resolvedOrder() {
      if (!this.order || !this.order.length) {
          return ["brand", "discount", "cPrice", "bPrice", "price", "about", "discriptions"];
      }
      return this.order.map((item) => (typeof item === "object" ? item.name : item));
    },
    hasDiscount() {
      const d = Number(this.value?.label?.discount?.text);
      return !isNaN(d) && d > 0;
    },
    finalConsumerPrice() {
      const bPrice = Number(this.value?.label?.bPrice?.text) || 0;
      const discount = Number(this.value?.label?.discount?.text) || 0;
      if (discount > 0 && discount <= 100) {
        return Math.round(bPrice - bPrice * (discount / 100));
      }
      return bPrice;
    },
    savedAmount() {
      const bPrice = Number(this.value?.label?.bPrice?.text) || 0;
      return Math.max(0, bPrice - this.finalConsumerPrice);
    },
  },
  watch: {
  'value.photo.profile'() {
    this.naturalRatio = null;
  },
    "value.label": {
      deep: true,
      immediate: true,
      handler() {
        this.setLabelKeys();
      },
    },
  },
  methods: {
      openLink(){
    window.open('https://qrland.ir', '_blank');
  },

     onImageLoad(src) {
    const img = new Image();
    img.src = typeof src === 'string' ? src : this.value?.photo?.profile;
    img.onload = () => {
      if (img.naturalWidth && img.naturalHeight) {
        this.naturalRatio = img.naturalWidth / img.naturalHeight;
      }
    };
  },
    shouldShowReadMore(text) {
      if (!text) return false;
      return text.length > 85 || (text.match(/\n/g) || []).length >= 2;
    },
    isValidValue(val) {
      if (val === null || val === undefined || val === "") return false;
      if (typeof val === "string") return val.trim().length > 0;
      if (typeof val === "number") return true;
      return !!val;
    },
    toPersian(val) {
      if (val === null || val === undefined) return "";
      if (typeof this.persian === "function") {
        return this.persian(String(val));
      }
      return String(val).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
    },
    formatPrice(val) {
      const num = Number(val);
      if (isNaN(num)) return this.toPersian(val);
      return this.toPersian(num.toLocaleString("en-US"));
    },
    setLabelKeys() {
      if (!this.value || !this.value.label) return;
      const currentOrder = Array.isArray(this.label) ? [...this.label] : [];
      // 'brand' اضافه شد
      const allowedKeys = ["brand", "discount", "cPrice", "bPrice", "price", "about", "discriptions"];

      const validKeys = allowedKeys.filter((key) =>
        this.isValidValue(this.value.label[key]?.text)
      );

      let newOrder = currentOrder.filter((item) => {
        const name = typeof item === "object" ? item.name : item;
        return validKeys.includes(name);
      });

      validKeys.forEach((key) => {
        if (!newOrder.some((item) => (typeof item === "object" ? item.name : item) === key)) {
          newOrder.push({ name: key });
        }
      });

      if (JSON.stringify(newOrder) !== JSON.stringify(this.label)) {
        this.label = newOrder;
      }
    },

  },
};
</script>

<style scoped>
/* قاب گوشی */
.luxury-phone-frame {
  max-width: 400px;
  width: 100%;
  direction: rtl;
  font-family: inherit;
  user-select: none;
  height: 650px;
  max-height: 85vh;
  position: relative;
  border-radius: 36px;
  background: #f8fafc;
  padding: 10px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18), 0 0 0 2px rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
}

/* ۱. هدر محصول (لبه پایینی صاف) */
.header-outer-container {
  width: 100%;
  padding-top: 5px;
}

.header-card {
  width: 100%;
  border-radius: 26px 26px 0 0 !important;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: none;
  transition: all 0.3s ease;
}

.header-bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 0;
  opacity: 0.15;
}

/* فریم عکس محصول منطبق با نسبت کارت */
.profile-hero-frame {
  position: relative;
  z-index: 2;
  border-radius: 20px;
  overflow: hidden;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.22);
  display: block;
}

.profile-hero-img {
  width: 100%;
  height: 100%;
  display: block;
}

.empty-header-placeholder {
  z-index: 1;
}

/* ۲. بدنه و نمایش نام محصول و فیلدها (لبه بالایی صاف) */
.body-scroll-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 0 0 24px 24px;
  padding-left: 2px;
  margin-bottom: 35px;
  -webkit-overflow-scrolling: touch;
}

.body-scroll-container::-webkit-scrollbar {
  width: 5px;
}
.body-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}
.body-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.4);
  border-radius: 10px;
}

.body-showcase {
  border-radius: 0 0 24px 24px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-top: none;
  min-height: 100%;
  overflow: hidden;
}

.body-bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 0;
  opacity: 0.1;
  pointer-events: none;
}

/* کارت سرتیتر نام محصول */
.product-title-card {
  cursor: default !important;
}

.product-main-name {
  font-size: 1.15rem;
  line-height: 1.55;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.border-top-light {
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
}

.store-subname {
  font-size: 0.88rem;
  opacity: 0.9;
}

.brand-tag-pill {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 100px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.brand-tag-text {
  font-size: 0.8rem;
}

.section-bullet {
  width: 5px;
  height: 16px;
  border-radius: 4px;
  display: inline-block;
}

.meta-title {
  font-size: 0.92rem;
}

/* کارت‌های مشخصات */
.lux-card {
  width: 100% !important;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.95);
  transition: all 0.25s ease;
  cursor: grab;
}

.lux-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

.lux-icon-box {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.25s ease;
}

.card-item-title {
  font-size: 0.9rem;
  letter-spacing: -0.2px;
}

.profit-highlight {
  font-size: 0.75rem;
  font-weight: 800;
  color: #059669;
  margin-top: 2px;
}

.discount-sub-info {
  font-size: 0.74rem;
  font-weight: 800;
  color: #e11d48;
  margin-top: 2px;
}

.discount-pill-tag {
  background: linear-gradient(135deg, #ff1744, #ff5252);
  color: #ffffff;
  font-size: 0.84rem;
  font-weight: 900;
  padding: 4px 10px;
  border-radius: 30px;
  box-shadow: 0 4px 10px rgba(255, 23, 68, 0.35);
}

.price-wrapper {
  display: flex;
  align-items: baseline;
}

.price-number {
  font-size: 1.25rem;
  font-weight: 900;
  letter-spacing: -0.5px;
}

.strikethrough-price {
  font-size: 0.78rem;
  color: #94a3b8;
  text-decoration: line-through;
  font-weight: 700;
  margin-bottom: -2px;
}

.price-curr {
  font-size: 0.74rem;
  font-weight: 700;
  color: #64748b;
  margin-right: 4px;
}

.desc-content {
  font-size: 0.85rem;
  line-height: 1.8;
  white-space: pre-line;
  word-break: break-word;
  transition: all 0.3s ease;
}

.desc-collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.read-more-btn {
  display: inline-flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 800;
  color: #0284c7;
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 6px;
  background: rgba(2, 132, 199, 0.08);
}

.lux-drag-handle {
  color: #cbd5e1 !important;
}

/* نشان آتش و تخفیف */
.badge-wrapper {
  position: absolute;
  left: 0px;
  top: 80%;
  z-index: 5;
  width: 75px;
  height: 75px;
}

.badge {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 50%;
  background: repeating-conic-gradient(rgb(248, 51, 51) 0deg 4deg, transparent 4deg 8deg);
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  position: relative;
}

.badge::before {
  content: "";
  position: absolute;
  top: 10%;
  left: 10%;
  width: 80%;
  height: 80%;
  background: rgb(255, 0, 0);
  border-radius: 50%;
  z-index: 1;
}

.badge span {
  position: relative;
  z-index: 2;
}

.fire {
  font-size: 24px !important;
  color: #ffffff !important;
  z-index: 10;
}

.fire2 {
  color: #ffffff;
}

/* افکت بوکه */
.bokeh-orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  mix-blend-mode: overlay;
}
.orb-1 {
  width: 140px;
  height: 140px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 70%);
  filter: blur(20px);
  top: -30px;
  left: -20px;
}
.orb-2 {
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 70%);
  filter: blur(24px);
  bottom: -40px;
  right: -30px;
}

/* انیمیشن‌ها */
.flame-anim { animation: flame-flicker 1.5s infinite alternate; }
@keyframes flame-flicker {
  0% { transform: scale(1) rotate(-3deg); }
  100% { transform: scale(1.15) rotate(3deg); }
}

.anim-jiggle { animation: jiggle 2.2s ease-in-out infinite; display: inline-block; }
@keyframes jiggle {
  0%, 100% { transform: rotate(0deg) scale(1); }
  15% { transform: rotate(-14deg) scale(1.15); }
  30% { transform: rotate(12deg) scale(1.15); }
  45% { transform: rotate(-6deg) scale(1.08); }
  60% { transform: rotate(4deg) scale(1); }
}

.anim-pulse-box { animation: pulse-shadow 2s infinite; }
@keyframes pulse-shadow {
  0% { box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.4); }
  70% { box-shadow: 0 0 0 8px rgba(225, 29, 72, 0); }
  100% { box-shadow: 0 0 0 0 rgba(225, 29, 72, 0); }
}

.anim-bounce { animation: mini-bounce 2s infinite ease-in-out; display: inline-block; }
@keyframes mini-bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-5px); }
  60% { transform: translateY(-2px); }
}

.anim-heartbeat { animation: heartbeat 1.6s ease-in-out infinite; display: inline-block; transform-origin: center; }
@keyframes heartbeat {
  0% { transform: scale(1); }
  14% { transform: scale(1.2); }
  28% { transform: scale(1); }
  42% { transform: scale(1.15); }
  70% { transform: scale(1); }
}

.anim-wiggle { animation: machine-wiggle 3s ease-in-out infinite; display: inline-block; }
@keyframes machine-wiggle {
  0%, 100% { transform: scale(1); }
  8% { transform: scale(1.1) rotate(-5deg); }
  16% { transform: scale(1.1) rotate(5deg); }
  24% { transform: scale(1.1) rotate(-4deg); }
  32% { transform: scale(1); }
}

.anim-glow-float { animation: glow-float 2.5s infinite alternate ease-in-out; }
@keyframes glow-float {
  0% { transform: translateY(1px) scale(0.96); }
  100% { transform: translateY(-3px) scale(1.06); }
}

.anim-tilt { animation: tilt-cycle 3.5s ease-in-out infinite; }
@keyframes tilt-cycle {
  0%, 100% { transform: rotate(0deg); }
  20% { transform: rotate(-7deg); }
  40% { transform: rotate(7deg); }
  60% { transform: rotate(0deg); }
}

@media (max-width: 600px) {
  .luxury-phone-frame {
    max-height: 80vh;
    padding: 6px;
    border-radius: 24px;
  }
}/* هدر محصول */
.header-outer-container {
  width: 100%;
  padding-top: 5px;
  height: auto !important; /* مطمئن شدن از اینکه ارتفاع قفل نیست */
}

.header-card {
  width: 100%;
  height: auto !important; /* ارتفاع متناسب با محتوای داخلش */
  border-radius: 26px 26px 0 0 !important;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: none;
  transition: all 0.3s ease;
  position: relative;
}

/* فریم عکس محصول */
.profile-hero-frame {
  position: relative;
  z-index: 2;
  border-radius: 18px;
  overflow: hidden;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-hero-img {
  width: 100%;
  height: 100%;
  display: block;
}
.brand-badge-pill {
  font-size: 0.95rem;
  font-weight: 800;
  padding: 4px 12px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.qr-floating-btn{
  position: absolute;
    z-index: 4;
    top: 18px;
    left: 14px;
}
</style>
